module.exports = __webpack_public_path__ + "img/kr-product-card3-item4-step3.444c1e7.png";